import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";

const orderCreatedStatusZodSchema = _orderStatusBaseZodSchema.merge(
    z.object({
        type: z.literal("CREATED"),
        createdBy: userIdZodSchema,
    }),
);
type OrderCreatedStatus = z.infer<typeof orderCreatedStatusZodSchema>;

const orderCreatedStatusFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly createdBy: UserId;
}): OrderCreatedStatus => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: "CREATED",
    createdBy: params.createdBy,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderCreatedStatus = (status: any): status is OrderCreatedStatus => {
    return status._type === "ORDER_STATE" && status.type === "CREATED";
};

export {
    isOrderCreatedStatus,
    orderCreatedStatusFactory,
    orderCreatedStatusZodSchema,
};
export type { OrderCreatedStatus };
